<template>
  <div class="view forget-view">
    <HeaderBar />
    <div class="form-wrap" v-show="type === 1">
      <div class="text--title">请输入手机号码</div>
      <div class="field-item">
        <input placeholder="手机号码" v-model="mobile" />
        <div class="text--error"></div>
        <van-button
          class="captcha-btn"
          plain
          type="primary"
          size="mini"
          @click="getCaptcha"
          :disabled="countingDown !== 0"
          >{{
            `${countingDown !== 0 ? `重新发送${countingDown}秒` : '发送验证码'}`
          }}</van-button
        >
      </div>
      <div class="field-item">
        <input placeholder="短信验证" v-model="code" />

        <div class="text--error"></div>
      </div>
    </div>
    <van-button type="primary" class="submit-btn" @click="onSubmitClick"
      >确定</van-button
    >
  </div>
</template>
<script>
import { Toast } from 'mint-ui'

import { Button, Checkbox, Dialog } from 'vant';
import apiUtil from '../../utils/apiUtil';
import apiConst from '../../consts/apiConst';
import HeaderBar from '../../components/HeaderBar';
let timer = null;
export default {
  name: 'login',
  components: {
    'van-button': Button,
    // 'van-checkbox': Checkbox,
    HeaderBar
  },

  data() {
    return {
      type: 1, //1-手机号码 2-账号密码 3-微信
      mobile: '',
      code: '',
      countingDown: 0,
    };
  },

  methods: {
    async getCaptcha() {
      const res = await apiUtil.post(apiConst.getCaptcha, {
        type: 2,
        mobile: this.mobile
      });
      if (res.success) {
        Toast({
          message: '发送成功',
          duration: 1000,
          background: '#8FC31E'
        });
        this.countingDown = 60;
        timer = setInterval(() => {
          this.countingDown--;
          if (this.countingDown === 0) {
            clearInterval(timer);
          }
        }, 1000);
      }
    },

    async onSubmitClick() {
      const res = await apiUtil.post(apiConst.submitForget, {
        mobile: this.mobile,
        code: this.code
      })
      if(res.success){
        if(res.password!=''){
            Dialog.alert({
              message: `临时随机密码：${res.password}，请登录后前往设置页面修改个人密码。`
            }).then(() => {
              // on close
              this.$router.push('login')
            });
        }else{
            Dialog.alert({
              message: `还没有注册帐号。`
            }).then(() => {
              // on close
              this.$router.push('login')
            });
        }
        
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.forget-view {
    height: 100%;
    padding-left: 34px
    padding-right: 34px
    .form-wrap {
      padding-top: 43px
      .text--title{
        font-size: 32px;
        color: #333;
        margin-bottom: 45px
      }
      .field-item {
        position: relative;
        padding-top: 22px
        padding-bottom 22px
        margin-bottom: 20px;
        border-bottom: 1PX solid #979797;

        .captcha-btn {
          position: absolute;
          width: 166px;
          height: 48px;
          line-height: 48px;
          right: 8px;
          bottom: 12px;
        }
      }
    }

    .submit-btn {
        margin-top: 64px;
        width: 100%
        height: 88px;
        line-height: 88px;
        background-color: #8FC31E;
        border-radius: 4px;
        color: #fff;
        text-align: center;
      }

}
</style>
